import { Radio } from "antd";
import React, { useState } from "react";
import Button from "../../Button";
import Overlay from "../../Overlay";
import HeaderOverlay from "../../Project/Header";
import Title from "../../Project/Title";
import "./index.scss";

import { useDispatch } from "react-redux";
import { openModal } from "../../../data/slices/modals";

function AssignPlanComptaModal({ open, handleClose, id, data }) {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleCloseFunc = (id) => {
    setSelectedOption(null);
    handleClose(id);
  };

  const dispatch = useDispatch();

  const handleNext = () => {
    dispatch(
      openModal("assign-plan-compta-confirm-modal", {
        selectedOption,
        ...data,
      })
    );
    handleClose(id);
    setSelectedOption(null);
  };

  return (
    <Overlay show={open} closable={true} onClick={handleCloseFunc}>
      <HeaderOverlay showlogo>
        <Title
          isDelete
          projectTitle={
            <div style={{ width: "95%" }}>
              Vous allez affecter une ligne du plan comptable par défaut à une
              catégorie.
            </div>
          }
          subTitle={`Affectation d'une ligne d'un plan comptable`}
        />

        <div style={{}}>
          <Radio.Group
            className="radio-group-assign-plan-compta"
            onChange={(e) => setSelectedOption(e.target.value)}
            value={selectedOption}
          >
            <Radio value="FUTURE_AND_EXISTING" className="radio-item">
             Appliquer mon choix aux futures écritures et à toutes les écritures déjà existantes dans la catégorie (à la place de l’éventuelle ligne comptable déjà existante). NOTE : les écritures appartenant à une période verrouillée ne seront pas modifiées ! 
            </Radio>
            <Radio value="FUTURE_ONLY" className="radio-item">
              Appliquer mon choix uniquement aux futures écritures (sans
              toucher aux écritures déjà existantes)
            </Radio>
          </Radio.Group>
        </div>

        <div className="verify-inputs-popup">
          <Button
            text={"Annuler"}
            onClick={() => {
              handleClose(id);
            }}
            className={"action-button"}
          />
          <Button
            text={"Valider"}
            onClick={handleNext}
            className={"action-button agree-action-button"}
            iconClassName={"delete-icon"}
            disabled={!selectedOption}
          />
        </div>
      </HeaderOverlay>
    </Overlay>
  );
}

export default AssignPlanComptaModal;
